export default [
	{
		name: 'integrations-thirdparties-sitebods',
		path:
			'/integrations/thirdparties/:thirdPartyId/integrations/:integrationId/sitebods',
		props: route => ({
			thirdPartyId: parseInt(route.params.thirdPartyId),
			integrationId: parseInt(route.params.integrationId),
			search: route.query.search || '',
			status: route.query.status || 'all',
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc',
			siteBodId: route.query.siteBodId,
			count: parseInt(route.query.count)
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/integration/sitebods/sitebods-page.vue'
			),
		meta: {
			permissions: ['integration.read']
		}
	}
];
